import { useMemo } from 'react';

import { useClinicCapabilities } from './useClinicCapabilities';
import { countryDefaults } from '../lib/countryDefaults';

/**
 * The defaults the ACTIVE clinic's country sets for a form — the national-id
 * rule, the phone's starting country, the empty map's view, the address model
 * (PM-0218, lib/countryDefaults.js). Every one is `undefined` — "as before" —
 * until the clinic's capabilities are known, and for an Iranian clinic.
 */
export function useCountryDefaults() {
  const caps = useClinicCapabilities();
  return useMemo(() => countryDefaults(caps), [caps]);
}

export default useCountryDefaults;
